module.exports = __webpack_public_path__ + "img/solution8.d6595152.png";